import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AppDashboardComponent } from './features/dashboard/dashboard.component';
import path from 'path';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'daily-work-report',
        loadChildren: () =>
          import('./features/daily-work-report/daily-work-report.module').then(
            (m) => m.DailyWorkReportModule
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'sample-doc',
        loadChildren: () =>
          import('./features/sample-doc/sample-doc.module').then(
            (m) => m.SampleDocModule
          ),
      },
      {
        path: 'extra',
        loadChildren: () =>
          import('./features/extra/extra.module').then((m) => m.ExtraModule),
      },
      {
        path: 'system',
        loadChildren: () =>
          import('./features/system/system.module').then((m) => m.SystemModule),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./features/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'storage',
        loadChildren: () =>
          import('./features/storage/storage.module').then(
            (m) => m.StorageModule
          ),
      },
      {
        path: 'category',
        loadChildren: () =>
          import('./features/category/category.module').then(
            (m) => m.CategoryModule
          ),
      },
      {
        path: 'chatbot-ai',
        loadChildren: () =>
          import('./features/chatbotAI/chatbot-ai.module').then((m) => m.ChatbotAIModule),
      },
      {
        path: 'backup-restore',
        loadChildren: () =>
          import('./features/backup-restore/backup-restore.module').then((m) => m.BackupRestoreModule),
      },
      {
        path: 'archives',
        loadChildren: () =>
          import('./features/archives/archives.module').then((m) => m.ArchivesModule),
      },
      {
        path: 'employee',
        loadChildren: () =>
          import('./features/employee/employee.module').then((m) => m.EmployeeModule),
      },
      {
        path: 'industry',
        loadChildren: () =>
          import('./features/industry/industry.module').then((m) => m.IndustryModule),
      },
      {
        path: 'service-package',
        loadChildren: () =>
          import('./admin/service-package/service-package.module').then((m) => m.ServicePackageModule),
      },
      {

        path: 'customer',
        loadChildren: () =>
          import('./admin/customer/customer.module').then((m) => m.CustomerModule),
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('./features/configuration/configuration.module').then((m) => m.ConfigurationModule),
      },
      {
        path: 'guide',
        loadChildren: () =>
          import('./features/guide/guide.module').then(
            (m) => m.GuideModule
          ),
      },
      {
        path: 'staticreport',
        loadChildren: () =>
          import('./features/statisticalreport/statictical-report.module').then(
            (m) => m.StaticticalReportModule
          ),
      },
      {
        path: 'datadump',
        loadChildren: () =>
          import('./features/data-dump/data-dump.module').then(
            (m) => m.DataDumpModule
          ),
      },
      {
        path: 'legalcontent',
        loadChildren: () =>
          import('./features/legalcontent/legalcontent.module').then(
            (m) => m.LegalcontentModule
          ),
      },
      {
        path: 'storagecl',
        loadChildren: () =>
          import('./features/storagecl/storagecl.module').then(
            (m) => m.StorageclModule
          ),
      },
      {
        path: 'paidmanage',
        loadChildren: () =>
          import('./features/paidmanage/paidmanage.module').then(
            (m) => m.PaidmanageModule
          ),
      },
      {
        path: 'authorization',
        loadChildren: () =>
          import('./features/authorization/authorization.module').then(
            (m) => m.AuthorizationModule
          ),
      },
      {
        path: 'labor-report',
        loadChildren: () =>
          import('./features/labor-report/labor-report.module').then(
            (m) => m.LaborReportModule
          ),
      },
      {
        path: 'timekeeping',
        loadChildren: () =>
          import('./features/timekeeping/timekeeping.module').then(
            (m) => m.timekeepingModule
          ),
      },
      {
        path: 'baocaonhancong',
        loadChildren: () =>
          import('./features/baocao-nhancong/baocao-nhancong.module').then(
            (m) => m.baocaoNhancongModule
          ),
      },
      {
        path: 'archivescl',
        loadChildren: () =>
          import('./features/archives-cl/archivescl.module').then((m) => m.ArchivesClModule),
      },
      {
        path: 'sample-doc-cl',
        loadChildren: () =>
          import('./features/sample-doc-cl/sample-doc.module').then(
            (m) => m.SampleDocClModule
          ),
      },
      {
        path: 'storage-cl',
        loadChildren: () =>
          import('./features/storage-chinhly/storage.module').then(
            (m) => m.StorageClModule
          ),
      },
      {
        path: 'unitprice',
        loadChildren: () =>
          import('./features/unitprice/unitprice.module').then(
            (m) => m.UnitPriceModule
          ),
      },
      {
        path: 'transfer',
        loadChildren: () =>
          import('./features/transfer/transfer.module').then(
            (m) => m.TransferModule
          ),
      },
      {
        path: 'rename',
        loadChildren: () =>
          import('./features/rename/rename.module').then(
            (m) => m.RenameModule
          ),
      },
      {
        path: 'phancong-kl',
        loadChildren: () =>
          import('./features/phancong-kl/phancong-kl.module').then(
            (m) => m.PhancongKlModule
          ),
      },
      {
        path: 'kiem-tra',
        loadChildren: () =>
          import('./features/kiem-tra/kiem-tra.module').then(
            (m) => m.KiemTraModule
          ),
      },
      {
        path: 'kiem-tra-gcn',
        loadChildren: () =>
          import('./features/kiem-tra-gcn/kiem-tra-gcn.module').then(
            (m) => m.KiemTraGcnModule
          ),
      },
      {
        path: 'data-aggregation',
        loadChildren: () =>
          import('./features/data-aggregation/data-aggregation.module').then(
            (m) => m.SoTheoDoiModule
          ),
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./features/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
